<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-02-22 14:37:43
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-27 15:48:05
-->
<template>
	<div class="record">
		<div class="multi-table">
			<multi-table :columns="columns" @gePartnerList="gePartnerList" :list="list" :total="total"></multi-table>
		</div>
	</div>
</template>
<script>
import { columns } from './columns';
import { exportOrderList } from '@/api/shopManage';
import { mapGetters } from 'vuex';
export default {
	name: 'record',
	data() {
		return {
			list: [],
			columns,
			total: '0',
			params: {
				page_index: 1,
				page_size: 10,
				action_type: '',
			},
			timer: null,
			action_type: '',
		};
	},
	computed: {
		...mapGetters(['defaultPlatform']),
	},
	created() {
		this.params.action_type = this.$route.query.action_type;
	},
	mounted() {
		this.getExportList();
		this.getInterval();
	},
	methods: {
		getInterval() {
			this.timer && clearInterval(this.timer);
			this.timer = setInterval(() => this.getExportList(), 5000);
		},
		async getExportList() {
			const {
				code,
				data: { list = [], page = {} },
			} = await exportOrderList(this.params);
			if (code === 0) {
				if (list.length === 0) {
					clearInterval(this.timer);
				}
				this.total = `${page.item_total}`;
				this.list = [...list];
			}
		},
		gePartnerList({ page_index, page_size }) {
			this.params.page_index = page_index;
			this.params.page_size = page_size;
			this.getExportList();
		},
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
};
</script>
